<template>
  <v-app>
    <!-- <apexcharts type="bar" :options="chartOptions" :series="series"></apexcharts> -->
      <v-toolbar>
        <v-btn>PRINT ALL</v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title><h4>WEIGH TAGS FOR VINTAGE</h4></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
            :items="allVintages"
            label="Vintage"
            v-model="selectedVintage">
          </v-select>
      </v-toolbar>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
        </v-card>
        <div>
           <v-data-table
            :headers='headers'
            :items='tableData'
            :search='search'
            v-model='selected'
            item-key='id'
            hide-actions
            class="elevation-1"
            >
            <template slot="items" slot-scope="props">
              <tr @click='rowClicked(props.item)'>
                <td width=50px @click="rowClicked(props.item)"><v-icon :color="getColor('WT')">{{ icon }}</v-icon></td>
                <td>{{ props.item.tagId + 5000 }}</td>
                <td>{{ props.item.dateFormatted }}</td>
                <td width=125px>{{ props.item.lot }}</td>
                <td>{{ props.item.Location.name }}</td>
                <td>{{ props.item.Location.appellation }}</td>
                <td>{{ props.item.variety }}</td>
                <td>{{ props.item.Location.region }}</td>
                <td class="text-xs-right">{{ props.item.binCount }}</td>
                <td class="text-xs-right">{{ props.item.tons }}</td>
              </tr>
            </template>
            <template slot="footer">
              <td colspan=9></td>
              <td>{{ totalWeight() }}</td>
            </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        </v-data-table>
      </div>
    </v-app>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import myMixins from '../mixins/myMixins'
import { GChart } from 'vue-google-charts'
export default {
  components: {
    apexcharts: VueApexCharts,
    GChart
  },
  data () {
    return {
      menu: false,
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        display: false,
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: []
        },
        yaxis: {

        },
        tooltip: {

        }
      },
      series: [{
        data: []
      }],
      appellations: [],
      zones: [],
      selected: [],
      selectedVintage: 2018,
      days: [],
      showSuccessBanner: false,
      editedItem: {
        clientId: 0,
        organic: '',
        bioDynamic: '',
        name: '',
        appellation: '',
        gateCode: '',
        applemoth: '',
        region: ''
      },
      editedIndex: -1,
      dialog: false,
      allVintages: [],
      search: '',
      currentDate: moment().format('YYYY-MM-DD'),
      headers: [
        { text: '', value: 'icon', sortable: false },
        { text: 'Tag #', value: 'tag', sortable: false },
        { text: 'Date', value: 'date', sortable: false },
        { text: 'Lot #', value: 'appellation', sortable: false },
        { text: 'Vineyard', value: 'lot', sortable: false },
        { text: 'Appellation', value: 'appellation', sortable: false },
        { text: 'Varietal', value: 'varietal', sortable: false },
        { text: 'Region', value: 'region', sortable: false },
        { text: 'Bin Count', value: 'binCount', sortable: false, align: 'right' },
        { text: 'Tons', value: 'tons', sortable: false, align: 'right' }
      ],
      tableData: []
    }
  },
  mixins: [myMixins],
  created () {
    this.retrieveAllVintages()
  },
  computed: {
    icon () {
      return this.getIcon('WT')
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  watch: {
    selectedVintage: function (oldDate, newDate) {
      this.retrieveWeightags()
    },
    client: function (oldClient, newClient) {
      this.retrieveWeightags()
    },
    vintage: function (oldV, newV) {
      this.retrieveWeightags()
    }
  },
  methods: {
    retrieveAllVintages () {
      axios
        .get(process.env.VUE_APP_BACKEND+'lots/uniqueVintageYears')
        .then(response => {
          this.allVintages = response.data.data
          this.selectedVintage = this.allVintages[0]
          this.retrieveWeightags()
        })
    },
    gotoToday () {
      this.currentDate = moment().format('YYYY-MM-DD')
    },
    totalWeight () {
      var total = 0
      this.tableData.forEach(function (item) {
        total += item.totalWeight
      })
      return this.roundTons(total / 2000)
    },
    rowClicked (value) {
      this.$router.push({
        path: '/weightag/'+value.id,
        query: {
          id: value.id
        }
      })
    },
    retrieveWeightags () {
      this.tableData = []
      axios
        .get(
          process.env.VUE_APP_BACKEND+'weightags?vintage=' + this.selectedVintage
        )
        .then((response) => {
          var latestDate
          response.data.data.forEach(wt => {
            if (this.days.length === 0 || moment(wt.date).format('YYYY-MM-DD') !== latestDate) {
              latestDate = moment(wt.date).format('YYYY-MM-DD')
              this.days.push([])
            }
            this.days[this.days.length-1].push(wt)
            if (!wt.Location) {
              wt.Location = {
                name: '',
                appellation: ''
              }
            }
          })
          this.tableData = response.data.data
        })
    }
  }
}
</script>
<style lang="css" scoped>

</style>
